export var responseOf = function (data, status) {
    if (status === void 0) { status = 200; }
    return function (res) { return res
        .status(status)
        .json(data); };
};
export var responseOfBuffer = function (type, data, status) {
    if (status === void 0) { status = 200; }
    return function (res) { return res
        .status(status)
        .type(type)
        .send(data); };
};
